/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Left_OnInputs */

const th_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ออกเมื่อ ${i?.date}`)
};

const en_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Left ${i?.date}`)
};

const ja_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}に退団`)
};

const zh_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`于 ${i?.date} 离队`)
};

const es_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se fue el ${i?.date}`)
};

const pt_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saiu em ${i?.date}`)
};

const id_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keluar pada ${i?.date}`)
};

const fr_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Parti le ${i?.date}`)
};

const tl_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Umalis noong ${i?.date}`)
};

const vi_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rời đi ngày ${i?.date}`)
};

const ko_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} 탈퇴`)
};

const de_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Verlassen am ${i?.date}`)
};

const ru_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ушёл ${i?.date}`)
};

const tr_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} tarihinde ayrıldı`)
};

const it_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uscito il ${i?.date}`)
};

const pl_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odszedł ${i?.date}`)
};

const uk_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Пішов ${i?.date}`)
};

const hi_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} को छोड़ा`)
};

const ar_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`غادر في ${i?.date}`)
};

const ms_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keluar pada ${i?.date}`)
};

const bn_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}-এ ছেড়েছেন`)
};

const zh_tw2_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`於 ${i?.date} 離隊`)
};

const zh_hk2_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`於 ${i?.date} 離隊`)
};

const ur_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date} کو چھوڑا`)
};

const fa_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`در ${i?.date} جدا شد`)
};

const sw_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aliondoka ${i?.date}`)
};

const nl_left_on = /** @type {(inputs: Left_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vertrokken op ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Left {date}" |
*
* @param {Left_OnInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const left_on = /** @type {((inputs: Left_OnInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Left_OnInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_left_on(inputs)
	if (locale === "ja") return ja_left_on(inputs)
	if (locale === "zh") return zh_left_on(inputs)
	if (locale === "es") return es_left_on(inputs)
	if (locale === "pt") return pt_left_on(inputs)
	if (locale === "id") return id_left_on(inputs)
	if (locale === "fr") return fr_left_on(inputs)
	if (locale === "tl") return tl_left_on(inputs)
	if (locale === "vi") return vi_left_on(inputs)
	if (locale === "ko") return ko_left_on(inputs)
	if (locale === "de") return de_left_on(inputs)
	if (locale === "ru") return ru_left_on(inputs)
	if (locale === "tr") return tr_left_on(inputs)
	if (locale === "it") return it_left_on(inputs)
	if (locale === "pl") return pl_left_on(inputs)
	if (locale === "uk") return uk_left_on(inputs)
	if (locale === "hi") return hi_left_on(inputs)
	if (locale === "ar") return ar_left_on(inputs)
	if (locale === "ms") return ms_left_on(inputs)
	if (locale === "bn") return bn_left_on(inputs)
	if (locale === "zh-TW") return zh_tw2_left_on(inputs)
	if (locale === "zh-HK") return zh_hk2_left_on(inputs)
	if (locale === "ur") return ur_left_on(inputs)
	if (locale === "fa") return fa_left_on(inputs)
	if (locale === "sw") return sw_left_on(inputs)
	if (locale === "nl") return nl_left_on(inputs)
	return en_left_on(inputs)
});